import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)
const _hoisted_8 = { class: "table" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Image:", -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Titre:", -1)
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Sous titre:", -1)
const _hoisted_16 = { key: 3 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Description:", -1)
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { key: 4 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Lien:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/liste-alaUnes",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7,
                _createTextVNode("Retour")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
              (_ctx.alaUne?.urlImage)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("td", null, [
                      _createElementVNode("img", {
                        src: _ctx.getUrlApiForFiles(_ctx.alaUne.urlImage),
                        alt: "Image",
                        width: "200",
                        height: "200"
                      }, null, 8, _hoisted_11)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.alaUne?.titre)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("td", null, _toDisplayString(_ctx.alaUne?.titre), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.alaUne?.subtitle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("td", null, _toDisplayString(_ctx.alaUne?.subtitle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.alaUne?.description)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("td", {
                      innerHTML: _ctx.alaUne.description
                    }, null, 8, _hoisted_18)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.alaUne?.link)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("td", null, _toDisplayString(_ctx.alaUne?.link), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}